import React, { Component } from 'react'
import { Button, Form, Table, Modal, Input, message, InputNumber, Spin,Row,Col, Switch, DatePicker } from 'antd'
//import {  } from '_src/api/api'
import './style/freshGoods.less'
import moment from 'moment'
import { Link } from 'react-router-dom'

const { Search } = Input
const { confirm } = Modal

@Form.create({ name: 'AddActivityForm' })
class FlashGoods extends Component{
    constructor(){
        super()
        this.state={
            isLoading:false,
            list: [
                {id: 1,title: '月饼抢购活动',status: true,startTime: '2020-09-16 00:00:00',endTime: '2020-09-30 00:00:00'},
                {id: 2,title: '粽子节活动',status: false,startTime: '2020-05-16 00:00:00',endTime: '2020-05-30 00:00:00'},
            ],
            pageData: {
                total: 0,
                current: 1,
            },
            params:{
                pageNum:0,
                pageSize:10,
            },
            addModalVisiable:false,
            addParams: {
                title: '',
                startTime: moment('YYYY-MM-DD'),
                endTime: moment('YYYY-MM-DD'),
                status: false
            },
        }
    }
    componentDidMount(){
        this.loadData()
    }
    //查询数据
    loadData(){
        
    }
    // 分页
    onPageChange = (e) => {
        const { params } = this.state
        params.pageNum = e.current - 1
        this.setState({
            params
        })
        this.loadData()
    }
    //添加活动
    handleSubmit = (e) => {
        const { addParams} = this.state
        e.preventDefault()
        this.props.form.validateFields((err, values) => {
            if (!err) {
                if(!addParams.startTime) {
                    message.warn('请选择开始日期！')
                    return
                }
                if(!addParams.endTime) {
                    message.warn('请选择结束日期！')
                    return
                }
                if(addParams.startTime > addParams.endTime) {
                    message.warn('开始日期不能大于结束日期')
                    return
                }
                addParams.status = values.status
                this.setState({addModalVisiable: false})
            }
        })
        
    }
    //编辑日期
    editActivity = (item) => {
        const { addParams } = this.state
        addParams.title = item.title
        addParams.startTime = item.startTime
        addParams.endTime = item.endTime
        addParams.status = item.status
        this.setState({
            addModalVisiable: true,
            addParams
        })
    }
    //选择开始日期
    handleChangeStartDate = (_, dateString) => {
        const { addParams } = this.state
        addParams.startTime = dateString
        this.setState({
            addParams
        })
    }
    //选择结束日期
    handleChangeEndDate = (_, dateString) => {
        const { addParams } = this.state
        addParams.endTime = dateString
        this.setState({
            addParams
        })
    }
    //上下架
    handleGrounding = (item) => {
        const groundingMName = item.status ? '下架':'上架'
        confirm({
            title: '温馨提示',
            content: (
                <p>您确定要将活动<span style = {{color: 'red', fontWeight: 'bold'}}>{item.title}{groundingMName}</span>吗?</p>
            ),
            onOk () {
              const hide = message.loading(`${groundingMName}中`, 0)
              hide()
            },
            onCancel () {
            
            },
        })
    }
    //删除活动
    delActivity = (item) => {
        confirm({
            title: '温馨提示',
            content: (
              <p>您确定要将活动<span style = {{color: 'red', fontWeight: 'bold'}}>{item.title}</span>删除吗?</p>
            ),
            onOk () {
              const hide = message.loading('删除中', 0)
              hide()
            },
            onCancel () {
            
            },
        })
    }
    //设置商品
    setGoods = (url) => {
        this.props.history.push(url)
    }
    //数据列
    columns = () =>{
        return [
            {
                title: <span>编号</span>,
                align: 'center',
                dataIndex: 'id',
                key: 'id',
            },
            {
                title: <span>活动标题</span>,
                align: 'center',
                dataIndex: 'title',
            },
            {
                title: <span>活动状态</span>,
                align: 'center',
                render:item =><div>{item.status?'活动进行中':'活动已结束'}</div>
            },
            {
                title: <span>开始时间</span>,
                align: 'center',
                dataIndex: 'startTime',
            },
            {
                title: <span>结束时间</span>,
                align: 'center',
                dataIndex: 'endTime',
            },
            {
                title: <span>操作</span>,
                align: 'center',
                width: 380,
                render: item => <div>
                    <Link style={{ marginRight: '10px' }} to={{ pathname: '/recommended/addFlash?id='+item.id }} target='_blank'>
                        <Button type="primary" onClick={this.create}>设置商品</Button>
                    </Link>                  
                    <Button  onClick={() => {
                      this.editActivity(item)
                    }} style={{ marginRight: '10px' }} type="primary">编辑</Button>
                    {
                        item.status?<Button  onClick={() => {
                            this.handleGrounding(item)
                        }} style={{ marginRight: '10px' }} type="danger">下架</Button>:<Button  onClick={() => {
                            this.handleGrounding(item)
                        }} style={{ marginRight: '10px' }} type="primary">上架</Button>
                    }
                    <Button  onClick={() => {
                      this.delActivity(item)
                    }} style={{ marginRight: '10px' }} type="danger">删除</Button>
                </div>,
            },
        ]
    }

    render(){
        const { isLoading, list, pageData, addModalVisiable, addParams } = this.state
        const { getFieldDecorator } = this.props.form
        return(
            <div className="freshGoods-page" style={{ padding: 20, backgroundColor: 'white' }}>
                {this.state.isLoading ? <Spin t1ip="Loading..." className="loading" size='large' /> : ''}
                <Form className="goodlist_from">
                    <div style={{ maxWidth: 900 }}>
                    <Row gutter={24}>
                        <Col span={8}>
                        <Form.Item label="活动标题" >
                            <Search placeholder="请输入活动标题" onSearch={this.onSearchName} enterButton />
                        </Form.Item>
                        </Col>
                        <Col span={8}>
                        <Form.Item>
                            <Button  type="primary" icon="plus" style={{ width: 160 }} onClick={()=>{
                                this.setState({
                                    addModalVisiable: true,
                                    addParams: {
                                        title: '',
                                        startTime: moment(),
                                        endTime: moment(),
                                        status: false
                                    },
                                })
                            }}>添加活动</Button>
                        </Form.Item>
                        </Col>
                    </Row>
                    </div>
                </Form>
                {
                !isLoading && (
                    <Table
                    columns={this.columns()}
                    dataSource={list}
                    bordered
                    rowKey="id"
                    pagination={{
                        current: pageData.current,
                        total: pageData.total,
                        pageSize: pageData.pageSize,
                    }}
                    onChange={this.onPageChange}
                    />
                )
                }
                <Modal
                    title="添加活动"
                    visible={addModalVisiable}
                    onCancel={() => {
                        this.setState({addModalVisiable: false})
                    }}
                    footer={false}
                    destroyOnClose
                    >
                    <Form
                        onSubmit={this.handleSubmit} 
                        className="advert-form" labelCol = {{span: 4}} wrapperCol = {{span: 18}}
                        style = {{maxWidth: 600, margin: (0, 'auto') }}
                    >
                        <Form.Item label="活动标题" number>
                            {getFieldDecorator('title', { 
                                initialValue: addParams.title,
                                rules: [{ required: true, message: '活动标题不能为空', }] 
                            })(
                            <Input placeholder="请输入活动标题" />)}
                        </Form.Item>
                        <Form.Item label = "开始时间">
                            <DatePicker onChange = {this.handleChangeStartDate} defaultValue = {moment(addParams.startTime)} style={{width:'355px'}}/> 
                        </Form.Item>
                        <Form.Item label = "结束时间">
                            <DatePicker onChange = {this.handleChangeEndDate} defaultValue = {moment(addParams.endTime)} style={{width:'355px'}}/> 
                        </Form.Item>
                        <Form.Item label="状态" className='flex'>
                            {getFieldDecorator('status', {
                                initialValue: addParams.status,
                                valuePropName: 'checked'
                            })(
                                <Switch checkedChildren="上架" unCheckedChildren="下架" />
                            )}
                        </Form.Item>
                        <Form.Item>
                            <div className="btnBox">
                                <Button  onClick={() => { this.setState({addModalVisiable: false}) }} style={{ marginRight: '10px' }}>取消</Button>
                                <Button  htmlType="submit" style={{ marginRight: '10px' }} type="primary">确定</Button>
                            </div>
                        </Form.Item>
                    </Form>
                 </Modal>
            </div>
        )
    }
}

export default FlashGoods